import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ScanEvent, ScanEventType } from './scan-navigation.model';

@Injectable({
  providedIn: 'root',
})
export class ScanNavigationService {
  // Number of the currenly scannable items in the screen
  scanLength = 0;

  // Scan pace in ms.
  scanInterval = 1000;

  // Current scan position
  scanIndex = -1;

  // Flag used to enable or disable the scan
  scanEnabled = false;

  // Notifies whenever the scan index changes
  scanEvents = new Subject<ScanEvent>();

  // Scan timer
  private scanTimer = null;

  // Flag to indicate if the scan cycle has been completed
  private cycleCompleted = false;

  constructor() {
    // TODO: Apenas para testes durante a implementacao
    // this.startScan();
  }

  /**
   * Starts the scan
   */
  startScan(scanInterval = 1500) {
    this.scanInterval = scanInterval;
    this.scanEnabled = true;
    this.restartScan();
  }

  /**
   * Restarts the scan
   */
  restartScan() {
    if (this.scanEnabled) {
      clearTimeout(this.scanTimer);
      this.scanIndex = -1;
      this.cycleCompleted = false;

      this.refreshScan();
    }
  }

  /**
   * Stops the scan
   */
  stopScan() {
    clearTimeout(this.scanTimer);
    this.scanIndex = -1;
    this.scanEnabled = false;
    this.cycleCompleted = false;
  }

  /**
   * Sets the scan length. It is related to the maximum number of items that can currently be scanned.
   *
   * @param length number of the currenly scannable items in the screen
   */
  setScanLength(length: number) {
    this.scanLength = length;
    this.restartScan();
  }

  /**
   * Refreshes the scan by moving to the next index
   */
  private refreshScan() {
    if (this.scanIndex >= this.scanLength - 1) {
      this.scanIndex = 0;
      this.cycleCompleted = true;
    } else {
      this.scanIndex++;
    }

    if (this.cycleCompleted) {
      this.scanEvents.next({ type: ScanEventType.cycleComplete });
    } else {
      this.scanEvents.next({
        type: ScanEventType.indexChange,
        value: this.scanIndex,
      });

      if (this.scanLength > 1) {
        // Sets a timeout for the next refresh
        this.scanTimer = setTimeout(() => {
          this.refreshScan();
        }, this.scanInterval);
      }
    }
  }
}
